import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import Component, { type TextHTMLComponentProps } from "./component";

const makeMapStateToProps = () => {
  const descriptionSelector = getSettingValueSelector(TargetSelector.Entity, "description");

  return (state: AppState, props: RootContainerProps): TextHTMLComponentProps => {
    return {
      description: descriptionSelector(state, props),
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
